<template>
  <div id="modal__editOffTrade">
    <h5>Order Information:</h5>
    <div :class="orderErrors.compNameEmpty" class="edit-container">
      <b>Company Name:</b>
      <input
        type="text"
        v-model="orderData.compNameTrade"
        name="Company Name"
        :data-originalData="originalData.CorporateName"
        @input="handleChange"
      />
    </div>
    <div id="edit__compInfo-container">
      <div id="edit__compInfoOne-wrapper">
        <div :class="orderErrors.compCodeEmpty" class="edit-container">
          <b>Company Code:</b>
          <input
            type="text"
            v-model="orderData.compCode"
            name="Company Code"
            :data-originalData="originalData.compCode"
            @input="(orderData.compCode = ('00000' + orderData.compCode).slice(-5)), handleChange"
          />
        </div>
        <div :class="orderErrors.pickupDateEmpty" class="edit-container">
          <b>Submitted By:</b>
          <input
            type="text"
            v-model="orderData.submittedBy"
            name="Submitted By"
            :data-originalData="originalData.submittedBy"
            @input="handleChange"
          />
        </div>
      </div>
      <div id="edit__compInfoTwo-container">
        <div :class="orderErrors.submittedByEmpty" class="edit-container">
          <b>Pickup Date:</b>
          <!-- <b-form-datepicker
            size="sm"
            v-model="orderData.pickupDate"
            @input="
              handleChange({
                target: {
                  name: 'Pickup Date',
                  value: orderData.pickupDate,
                  originalData: originalData.pickupDate,
                },
              })
            "
          ></b-form-datepicker> -->
          <datepicker
            size="sm"
            v-model="orderData.pickupDate"
            @date-update="dateClicked"
            :enable-time-picker="false"
            :timezone="{ timezone: 'UTC', exactMatch: true }"
            :dark="getUserInfo.UserTheme == 'Dark' ? true : false"
            ignore-time-validation
            week-start="0"
            auto-apply
            vertical 
            arrow-navigation
            required
          ></datepicker>
        </div>
      </div>
    </div>
    <div class="edit-container__vins">
      <b>Returning Vins Remaining:</b>
      <div class="edit__truckInfo-container">
        <div
          v-for="(truck, index) in orderData.returningVins"
          :key="truck.id"
          :class="{ 'edit__lock--styleOverride': truck.assignedStatus == 'assigned' }"
        >
          <div class="edit__truckInfo">
            <b class="label">Unit Number:</b>
            <input
              :disabled="truck.assignedStatus == 'assigned' || (truck.statusID != 5 && truck.statusID != 0 && onboardingStatus != 0)"
              required
              maxlength="8"
              @input="e => ((theDuplicate = ''), (vinsEdited = true), (e.target.value = e.target.value.toUpperCase()))"
              v-model="truck.vin"
            />
            <b>Odometer:</b>
            <input
              :disabled="truck.assignedStatus == 'assigned'"
              required
              v-mask="'#########'"
              v-model="truck.odometer"
            />
            <p v-if="truck.assignedStatus == 'assigned'" class="edit__lockText">Carrier Assigned</p>
            <p
              v-if="truck.assignedStatus != 'assigned' && validatedUnits[truck.vin]"
              class="edit__unitStats valid"
            >
              VALID UNIT NUMBER
            </p>
            <p
              v-else-if="truck.assignedStatus != 'assigned' && !validatedUnits[truck.vin] && !vinsEdited"
              class="edit__unitStats invalid"
            >
              UNIT NOT VALIDATED
            </p>
            <p
              v-else-if="truck.assignedStatus != 'assigned' && vinsEdited && theDuplicate == ''"
              class="edit__unitStats invalid"
            >
              Test Required
            </p>
            <p
              v-else-if="truck.assignedStatus != 'assigned' && vinsEdited && theDuplicate != ''"
              class="edit__unitStats invalid"
            >
              DUPLICATE
            </p>
              
            <font-awesome-icon
              @click="truck.assignedStatus != 'assigned' && handleConvertCheck(index)"
              :class="truck.assignedStatus != 'assigned' ? 'convert_to_on_rent' : 'convert__lock'"
              :icon="truck.assignedStatus != 'assigned' ? 'random' : 'lock'"
            />
          </div>
          <div class="convert__truckInfo" v-if="confirmConvert && truck.vin == convertVin">
            <p class="convert__are_you_sure space-right">Are you sure you want to convert this traded unit into an On Rent?<br>
              This will remove the Off Rent half of the trade.</p>
            <BButton 
              variant="danger" 
              class="convert__btn"
              @click="handleConvert(index)"
              >Yes
            </BButton>
            <BButton 
              variant="secondary" 
              class="convert__btn"
              @click="confirmConvert = false"
              >No
            </BButton>
          </div>
        </div>
        <div class="edit__btns-container">
          <div @click="handleVinTest" id="edit__addVin">
            <p id="edit__test">Validate Unit Number(s)</p>
          </div>
        </div>
      </div>
    </div>
    <h5>Pickup Information:</h5>
    <div class="edit__pickInfo">
      <div id="edit__pickupInfoOne-container">
        <div :class="orderErrors.pickupNameEmpty" class="edit-container">
          <b>Name:</b>
          <input
            type="text"
            v-model="orderData.pickupName"
            name="Pickup Name"
            :data-originalData="originalData.pickupName"
            @input="handleChange"
          />
        </div>  
        <div :class="orderErrors.pickupEmailEmpty" class="edit-container">
          <b>Email:</b>
          <input
            type="text"
            v-model="orderData.pickupEmail"
            name="Pickup Email"
            :data-originalData="originalData.pickupEmail"
            @input="handleChange"
          />
        </div>
        <div :class="orderErrors.pickupPhoneEmpty" class="edit-container">
          <b>Phone:</b>
          <input
            name="Pickup Name"
            :data-originalData="originalData.pickupPhone"
            @input="handleChange"
            v-mask="validatePickupPhone"
            type="text"
            v-model="orderData.pickupPhone"
          />
        </div>
        <div class="edit-container">
          <b>Alt. Phone:</b>
          <input
            name="Pickup Alt Phone"
            :data-originalData="originalData.pickupAltPhone"
            @input="handleChange"
            placeholder="*optional"
            v-mask="validatePickupAltPhone"
            type="text"
            v-model="orderDataUnrequired.pickupAltPhone"
          />
        </div>
      </div>
      <div id="edit__pickupInfoOne-container">
        <div :class="orderErrors.pickupStreetAddressEmpty" class="edit-container">
          <b>Street Address:</b>
          <div>
            <input
              name="Pickup Address"
              :data-originalData="originalData.pickupStreetAddress"
              @input="handleChange"
              type="text"
              v-model="orderData.pickupStreetAddress"
            />
          </div>
        </div>
        <div class="edit-container">
          <b>Street Address 2:</b>
          <div>
            <input
              name="Pickup Address2"
              :data-originalData="originalData.pickupStreetAddress2"
              @input="handleChange"
              type="text"
              placeholder="*optional"
              v-model="orderDataUnrequired.pickupStreetAddress2"
            />
          </div>
        </div>
        <div :class="orderErrors.pickupCityEmpty" class="edit-container">
          <b>City:</b>
          <div>
            <input
              name="Pickup City"
              :data-originalData="originalData.pickupCity"
              @input="handleChange"
              type="text"
              v-model="orderData.pickupCity"
            />
          </div>
        </div>
        <div :class="orderErrors.pickupStateEmpty" class="edit-container">
          <b>State:</b>
          <div>
            <input
              name="Pickup State"
              :data-originalData="originalData.pickupState"
              @input="handleChange"
              type="text"
              v-model="orderData.pickupState"
            />
          </div>
        </div>
        <div :class="orderErrors.pickupZipEmpty" class="edit-container">
          <b>Zip Code:</b>
          <div>
            <input
              name="Pickup Zip"
              :data-originalData="originalData.pickupZip"
              @input="handleChange"
              type="text"
              v-model="orderData.pickupZip"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="submit-container">
      <BButton variant="success" @click="handleSaveChanges">Save Changes</BButton>
      <p id="error">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import constants from '@/assets/constants';

export default {
  name: 'editOffboarding',
  // computed: mapGetters(['getCurrentNoteOrder']),
  data() {
    return {
      error: '',
      vinsEdited: false,
      validatedUnits: {},
      originalData: {},
      orderData: {
        changedData: {},
        compNameTrade: '',
        compCode: '',
        pickupDate: null,
        submittedBy: '',
        returningVins: [],
        deletedVins: [],
        pickupName: '',
        pickupEmail: '',
        pickupPhone: '',
        pickupStreetAddress: '',
        pickupCity: '',
        pickupState: '',
        pickupZip: '',
      },
      orderDataUnrequired: {
        pickupAltPhone: '',
        pickupStreetAddress2: '',
      },
      orderErrors: {
        compNameEmpty: '',
        compCodeEmpty: '',
        pickupDateEmpty: '',
        submittedByEmpty: '',
        returningVinsEmpty: '',
        deletedVinsEmpty: '',
        pickupNameEmpty: '',
        pickupEmailEmpty: '',
        pickupPhoneEmpty: '',
        pickupStreetAddressEmpty: '',
        pickupStreetAddress2Empty: '',
        pickupCityEmpty: '',
        pickupStateEmpty: '',
        pickupZipEmpty: '',
      },
      convertVin: '',
      confirmConvert: false,
      convertData: {},
      statusList: [],
      onboardingStatus: '',
      theDuplicate: '',
    };
  },
  computed: {
    ...mapGetters(['getCurrentNoteOrder', 'getUserInfo']),
    validatePickupPhone() {
      if (this.orderData.pickupPhone == '') {
        return '';
      } else if (this.orderData.pickupPhone && (this.orderData.pickupPhone.substring(0, 1) == '+' || this.orderData.pickupPhone.substring(0, 1) == '1')) {
        return ['+# (###) ###-####', '+## (###) ###-####']
      } else {
        return '(###) ###-####';
      }
    },
    validatePickupAltPhone() {
      if (this.orderData.pickupAltPhone == '') {
        return '';
      } else if (this.orderData.pickupAltPhone && (this.orderData.pickupAltPhone.substring(0, 1) == '+' || this.orderData.pickupAltPhone.substring(0, 1) == '1')) {
        return ['+# (###) ###-####', '+## (###) ###-####']
      } else {
        return '(###) ###-####';
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(['closeModal']),
    init() {
      if (this.getCurrentNoteOrder.StatusList != null) {
        this.statusList = this.getCurrentNoteOrder.StatusList.split(',').map(unitStat => {
          const status = unitStat.split(' - ');
          return {
            unitNumber: status[0],
            statusID: status[1]
          }
        })
      }
      this.onboardingStatus = this.getCurrentNoteOrder.OnboardingStatus;
      this.orderData.TradeFormID = this.getCurrentNoteOrder.TradeFormID;
      this.orderData.FormHistoryID = this.getCurrentNoteOrder.FormHistoryID;
      this.orderData.OffRentFormID = this.getCurrentNoteOrder.OffRentFormID;
      this.orderData.compNameTrade = this.getCurrentNoteOrder.CorporateName;
      this.orderData.compCode =
        this.getCurrentNoteOrder.CompanyNumber || this.getCurrentNoteOrder.CompanyCode || 'CA000000';
      this.orderData.compCode = this.orderData.compCode.toString();

      this.orderData.pickupDate =
        this.getCurrentNoteOrder.ReturnDate || this.getCurrentNoteOrder.DateNeeded;
      this.orderData.submittedBy = this.getCurrentNoteOrder.SubmitteeName;
      this.orderData.returningVins = this.getCurrentNoteOrder.Trucks
        ? this.getCurrentNoteOrder.Trucks.split(',').map(vinInfo => {
            const response = vinInfo.split(' - ');
            let StatusID = 0;
            for (let i = 0; i < this.statusList.length; i++) {
              if (response[0] == this.statusList[i].unitNumber) {
                StatusID = this.statusList[i].statusID;
              }
            }
            return {
              originalInfo: {
                vin: response[0],
                odometer: response[1],
                assignedStatus: response[2],
              },
              vin: response[0],
              odometer: response[1],
              assignedStatus: response[2],
              statusID: StatusID
            };
          })
        : this.getCurrentNoteOrder.Truck.split(' # ,').map(vinInfo => {
            const response = vinInfo.split(' - ');
            let StatusID = 0;
            for (let i = 0; i < this.statusList.length; i++) {
              if (response[0] == this.statusList[i].unitNumber) {
                StatusID = this.statusList[i].statusID;
              }
            }
            return {
              originalInfo: {
                vin: response[0],
                odometer: response[5].replace(' #', '').trim(),
                assignedStatus: response[2],
              },
              vin: response[0],
              odometer: response[5].replace(' #', '').trim(),
              assignedStatus: response[2],
              statusID: StatusID
            };
          });

      this.orderData.pickupName =
        this.getCurrentNoteOrder.PickupName || this.getCurrentNoteOrder.Name;
      this.orderData.pickupEmail = this.getCurrentNoteOrder.PickupEmail || this.getCurrentNoteOrder.Email;
      this.orderData.pickupPhone =
        this.getCurrentNoteOrder.PickupPhone || this.getCurrentNoteOrder.Phone;
      this.orderDataUnrequired.pickupAltPhone = this.getCurrentNoteOrder.PickupAltPhone || this.getCurrentNoteOrder.AltPhone;
      this.orderData.pickupStreetAddress =
        this.getCurrentNoteOrder.PickupStreetAddress || this.getCurrentNoteOrder.StreetAddress;
      this.orderDataUnrequired.pickupStreetAddress2 =
        this.getCurrentNoteOrder.PickupStreetAddress2 || this.getCurrentNoteOrder.Street2;
      this.orderData.pickupCity =
        this.getCurrentNoteOrder.PickupCity || this.getCurrentNoteOrder.City;
      this.orderData.pickupState =
        this.getCurrentNoteOrder.PickupState || this.getCurrentNoteOrder.State;
      this.orderData.pickupZip = this.getCurrentNoteOrder.PickupZip || this.getCurrentNoteOrder.Zip;

      this.originalData = { ...this.orderData };

      this.convertData = { ...this.orderData };

      this.convertData.SecondKeyTrade = 
        !!this.getCurrentNoteOrder.SecondKeyTrade || !!this.getCurrentNoteOrder.SecondKeyCount;
      this.convertData.MidsizeCountTrade = 
        this.getCurrentNoteOrder.MidsizeCountTrade || this.getCurrentNoteOrder.MidsizeCount;
      this.convertData.HalfTonCountTrade = 
        this.getCurrentNoteOrder.HalfTonCountTrade || this.getCurrentNoteOrder.HalfTonCount;
      this.convertData.ThreeQuarterTonCountTrade =
        this.getCurrentNoteOrder.ThreeQuarterTonCountTrade ||
        this.getCurrentNoteOrder.ThreeQuarterTonCount;
      this.convertData.OneTonFlatCountTrade =
        this.getCurrentNoteOrder.OneTonFlatCountTrade || this.getCurrentNoteOrder.OneTonFlatCount;
      this.convertData.OneTonServiceCountTrade =
        this.getCurrentNoteOrder.OneTonServiceCountTrade ||
        this.getCurrentNoteOrder.OneTonServiceCount;
      this.convertData.pickupAltPhone = this.getCurrentNoteOrder.PickupAltPhone || this.getCurrentNoteOrder.AltPhone;
      this.convertData.pickupStreetAddress2 =
        this.getCurrentNoteOrder.PickupStreetAddress2 || this.getCurrentNoteOrder.Street2;
      this.convertData.PONumber =
        this.getCurrentNoteOrder.PONumber || this.getCurrentNoteOrder.PONumberTrade;
      this.convertData.raName = this.getCurrentNoteOrder.RANameTrade || this.getCurrentNoteOrder.RAName;
      this.convertData.raPhone = this.getCurrentNoteOrder.RAPhoneTrade || this.getCurrentNoteOrder.RAPhone;
      this.convertData.raEmail = this.getCurrentNoteOrder.RAEmailTrade || this.getCurrentNoteOrder.RAEmail;
      this.convertData.raFax = this.getCurrentNoteOrder.RAFaxTrade || this.getCurrentNoteOrder.RAFax;
      this.convertData.NumTrucksReturning = this.getCurrentNoteOrder.NumTrucks;
      this.convertData.ReturnTrucksRemaining = this.getCurrentNoteOrder.TrucksRemaining;
      this.convertData.NewTrucksRemaining = this.getCurrentNoteOrder.NewTrucksRemaining || this.getCurrentNoteOrder.ReturnTrucksRemaining;
      this.convertData.specialInstructions = this.getCurrentNoteOrder.SpecialInstructions;
      this.convertData.insuranceType = this.getCurrentNoteOrder.InsuranceType;
    },
    async handleSaveChanges() {
      // * Validates fields
      if (!(await this.handleValidate())) return;

      // * Validates Unit Numbers
      await this.handleVinTest();

      const testEnteredVins = this.orderData.returningVins.map(
        vinInfo => this.validatedUnits[vinInfo.vin]
      );

      if (testEnteredVins.includes(false)) {
        setTimeout(() => (this.error = ''), 5000);
        this.error = 'All edited vins must be tested and valid';
        return;
      }

      const vins = this.orderData.returningVins;
      // * Are there duplicate vins in the array?
      for (let i = 0; i < vins.length; i++) {
        for (let j = 0; j < vins.length; j++) {
          if (i !== j && vins[i].vin === vins[j].vin) {
            setTimeout(() => (this.error = ''), 5000);
            this.error = '*The entered vins contain duplicates';
            return;
          }
        }
      }

      if (this.orderData.compCode == '' || this.orderData.compCode == null) {
        this.error = 'Company Code is required to edit an order.'
      }

      if (this.error) return;

      this.orderData = { ...this.orderData, ...this.orderDataUnrequired };
      await axios
        .put(`${constants.BASE_URL}/api/trade/off/edit`, this.orderData)
        .then(res => {
          // if (this.$route.name === 'transport') {
          //   this.$socket.emit('transportCardsRefresh');
          // } else {
          //   this.$socket.emit('offBoardingCardsRefresh');
          // }
          // this.closeModal();
          this.$emit('closeModal');
        })
        .catch(err => {
          setTimeout(() => (this.error = ''), 5000);
          this.error = '*All fields must be filled please...';
          console.log(err);
        });
    },
    handleAddVin() {
      this.orderData.returningVins.push({
        vin: 'UPDATE',
        odometer: '000000',
      });
    },
    handleRemoveVin(index) {
      this.orderData.deletedVins.push(this.orderData.returningVins[index]);
      this.orderData.returningVins.splice(index, 1);
    },
    async handleVinTest() {
      let completedList = [];
      this.theDuplicate = '';
      // Check if any completed units are duplicated. First get 
      await axios
        .get(`${constants.BASE_URL}/api//trade-form/completed-truck-list/${this.orderData.TradeFormID}`, {
            headers: {
              Authorization: localStorage.getItem('token'),
            },
          })
          .then(res => {
            completedList = res.data;
          }).catch(err => {
            console.log('error: ', err);
          });
      let duplicates = new Set();
      // Add completed Units to duplicates set
      for (let i = 0; i < completedList.length; i++) {
        duplicates.add(completedList[i].UnitNumber);
      }
      const containsDuplicates = this.orderData.returningVins.some(({ vin }) => {
        if (duplicates.has(vin)) {
          this.theDuplicate = vin;
          return true;
        } 
        duplicates.add(vin);
      });
      if (containsDuplicates) {
        setTimeout(() => (this.error = ''), 7000);
        this.error = 'Cannot use duplicate vins. ' + this.theDuplicate + ' has already been used or completed on this order.';
        return;
      }

      // Checks to make sure the unit exist in the Truck Table
      await axios
        .post(`${constants.BASE_URL}/api/truck/vin-test`, {
          vins: this.orderData.returningVins,
          FormHistoryID: this.orderData.FormHistoryID,
        })
        .then(res => {
          this.validatedUnits = res.data;
          this.vinsEdited = false;
        })
        .catch(err => {
          console.log(error);
        });
    },
    handleValidate() {
      // - ============ SET THE TRUCKS REMAINING ============
      const validationData = { ...this.orderData };
      let validInformation = true;

      // * Nullable fields
      delete validationData.OffRentFormID;
      delete validationData.deletedVins;
      delete validationData.pickupStreetAddress2;
      delete validationData.pickupZip;
      delete validationData.pickupAltPhone;
      this.getCurrentNoteOrder.NumTrucks !== this.getCurrentNoteOrder.TrucksRemaining &&
        delete validationData.returningVins;

      this.error = '';
      console.log('validation data: ', validationData);
      Object.values(validationData).forEach((field, index) => {
        try {
          if (
            (field !== false && !field && index !== 8) ||
            (field.toString().trim() === '' && index !== 8)
          ) {
            this.orderErrors[`${Object.keys(validationData)[index]}Empty`] = 'error-box';
            validInformation = false;
          } else {
            this.orderErrors[`${Object.keys(validationData)[index]}Empty`] = '';
          }

          if (!validInformation) {
            setTimeout(() => (this.error = ''), 6000);
            this.error = '*All the fields must be filled...';
          }
        } catch (err) {
          this.orderErrors[`${Object.keys(validationData)[index]}Empty`] = 'error-box';
          validInformation = false;
          this.error = '*All fields must be filled...';
        }
      });
      return validInformation;
    },
    handleChange(e) {
      let { name, value } = e.target;
      let oldValue = e.currentTarget
        ? e.currentTarget.getAttribute('data-originalData')
        : e.target.originalData;
      if (oldValue === value) return delete this.orderData.changedData[name];
      name = name.replace(',', '').replace('!', '');
      value = value.replace(',', '').replace('!', '');
      if (oldValue !== null) {
        oldValue = oldValue.replace(',', '').replace('!', '');
      }

      this.orderData.changedData[name] = `${name}: ${oldValue}!${name}: ${value}`;
    },
    dateClicked(date) {
      this.handleChange({
        target: {
          name: 'Pickup Date',
          value: date.toISOString().split('T')[0],
          originalData: this.originalData.pickupDate,
        },
      })
    },
    handleConvertCheck(index) {
      this.convertVin = this.orderData.returningVins[index].originalInfo.vin;
      this.confirmConvert = true;
      this.convertData.convertVin = this.convertVin;
      console.log('vin: ', this.convertVin);
      console.log('all data: ', this.convertData);
    },
    async handleConvert(index) {
      await axios.post(`${constants.BASE_URL}/api/trade/off/convert`, this.convertData)
        .then(res => {
          this.confirmConvert = false;
          this.$socket.emit('transportCardsRefresh');
          this.init();
          // this.closeModal();
          this.$emit('closeModal');
        })
        .catch(err => {
          console.log(err);
          setTimeout(() => (this.error = ''), 6000);
          this.error = 'Failed to convert trade...';
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/index';

#modal__editOffBoarding {
  width: 100%;
}

#error {
  margin-left: 15px;
  color: #df4b5b;
}

.error-box {
  border-radius: 3px;
  border: 1px solid #df4b5b;
  max-width: 300px;
  padding: 5px;
  box-sizing: border-box;
  margin-right: 5px;
}

.edit-container {
  @include F(flex-start, center);
  width: 100%;
  margin: 5px 0;
  b {
    margin: 0 15px 0 0;
    white-space: nowrap;
  }
  input {
    flex: 1 !important;
    width: 100%;
    outline: none;
    border: 1px solid var(--default-dropdown-bg);
    border-radius: 5px;
    background: var(--modal-bg-color);
    padding-left: 5px;
    margin-right: 5px;
  }
}

#edit__ttl {
  position: absolute;
  top: 0;
  font-weight: 600;
  transform: translateY(-130%);
}

.edit-container__vins {
  @include F(center, flex-start, column);
  width: 100%;
  margin: 10px 0;
  b {
    margin: 0 5px 0 0;
  }
  input {
    max-width: 90% !important;
    background: none;
    border: none;
    outline: none;
  }
}

.submit-container {
  display: flex;
  align-items: center;
}

.edit__plus {
  color: green;
  cursor: pointer;
  margin: 0 5px 0;
  font-size: 0.8rem;
}

.edit__minus {
  color: firebrick;
  cursor: pointer;
  margin: 0 5px;
  font-size: 0.8rem;
}

.edit__lock {
  color: rgb(202, 19, 19);
  margin: 0 5px;
  font-size: 0.8rem;
}

.edit__lock--styleOverride {
  background: #db0f0f1c !important;
  border: 1px solid red;
  margin: 3px 0;
  width: 100%;
  b {
    font-weight: 700;
  }
  input {
    font-size: 0.8rem;
    width: 16%;
  }
}

.edit__lockText {
  font-weight: 700;
  text-transform: uppercase;
  color: #111;
}

.valid,
.invalid {
  font-weight: 600;
  min-width: 150px;
}

.valid {
  color: green;
}

.invalid {
  color: firebrick;
}

.edit__btns-container {
  margin: 10px 0 0;
  padding: 0 10px 0 0;
  @include F($j: space-between);
  width: 100%;
}

#edit__addVin {
  cursor: pointer;
  @include F();
  p {
    font-weight: 600;
  }
}

#edit__test {
  color: orangered;
  &:hover {
    text-decoration: underline;
  }
}

.edit__truckInfo {
  background: var(--edit-bg-color);
  margin: 3px 0;
  width: 100%;
  .label {
    min-width: 105px;
  }
  b {
    font-weight: 700;
  }
  input {
    font-size: 0.8rem;
    // width: calc(40% - 5px);
    min-width: 75px;
    margin-right: 5px;
  }
  input:disabled {
    background-color: var(--default-disabled-color);
    cursor: not-allowed;
  }
}

.convert__truckInfo {
  background: #ffc107;
  margin: 3px 0;
  width: 100%;
  b {
    font-weight: 700;
  }
  input {
    font-size: 0.8rem;
    width: 40%;
  }
}

@media screen and (min-width: 850px) {
  .edit__truckInfo-container {
    @include F(center, flex-start, column);
    margin: 0 0 20px 30px;
    width: 80%;
  }

  #edit__compInfo-container {
    @include F(flex-start, flex-start);
  }

  .edit__truckInfo {
    @include F(flex-start, center);
    input {
      // width: calc(16% - 5px);
      margin-right: 5px;
    }
  }

  .edit__pickInfo {
    @include F(flex-start, flex-start);
    margin: 0 0 15px;
  }

  .convert__truckInfo {
    @include F(flex-start, center);
    input {
      width: 16%;
    }
  } 

  #edit__pickupInfoOne-container {
    width: 50%;
  }

  #edit__pickupInfoTwo-container {
    width: 50%;
  }
}

.convert_to_on_rent {
  color: gray;
  cursor: pointer;
  margin: 0 5%;
  font-size: 0.8rem;
}

.convert__lock {
  color: rgb(202, 19, 19);
  margin: 0 5%;
  font-size: 0.8rem;
}

.convert__are_you_sure {
  margin: 5px 15px;
  font-size: .8rem;
  font-weight: 400;
}

.space-right {
  margin-right: 35px;
}

.italic-bold {
  font-style: italic;
  font-weight: 500;
}

.convert__btn {
  margin: 5px;
}
</style>
